export default class NewsmeigaraTrendService {
  getAll() {
    return fetch("https://api.tradersr.com/api/newsmeigaratrend")
      .then(res => res.json());
  }
}